import React, { useEffect, useState } from "react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import CustomBreadcrumb from "../components/CustomBreadcrumb";
import PageTitle from "../components/PageTitle";
import CardWrapper from "../layouts/CardWrapper";
import { Modal } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Dropdown from "react-bootstrap/Dropdown";
import Image from "react-bootstrap/Image";
import Button from "react-bootstrap/Button";
import { Link, useNavigate } from "react-router-dom";
import { useDebounce } from "../hooks/useDebounce"; // adjust path as needed
import Tabs from "../components/Tabs/Tabs";
import { useAlert } from "../contexts/AlertContext";
import { useSidebar } from "../contexts/SidebarContext";
import TablePagination from "../components/TablePagination/TablePagination";
import {
  getTemplates,
  deleteTemplateById,
  createTemplate,
} from "../services/templateService";
import {
  CopyIcon,
  EditIcon,
  TrashIcon,
  DownloadIcon,
  InfoIcon,
  PlusIcon,
} from "../components/SVGIcon";
import ReportPreview from "./ReportPreview/ReportPreview";
import { listExpertUsers } from "../services/userService";

const ReportHub = () => {
  const [reportFilter, setReportFilter] = useState("template");
  const [activeTab, setActiveTab] = useState("all");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [range, setRange] = useState({ from: null, to: null });
  const [showModal, setShowModal] = useState(false);
  const [selectedPage, setSelectedPage] = useState(1);
  const [showCopyModal, setShowCopyModal] = useState(false);
  const [templatesShow, setTemplatesShow] = useState([]);
  const [templateToCopy, setTemplateToCopy] = useState(null);
  const [templateToPreview, setTemplateToPreview] = useState(null);
  const [totalTemplatesCount, setTotalTemplatesCount] = useState(0);
  const [templatesToDelete, setTemplatesToDelete] = useState(null);
  const { showAlert } = useAlert();
  const { collapseSidebarForReportHub, expandSidebarForReportHub } = useSidebar();
  const [loading, setLoading] = useState(false);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [showReportInfo, setShowReportInfo] = useState(false);
  const [showUsersDropdown, setShowUsersDropdown] = useState(false);
  const [expertUsers, setExpertUsers] = useState([]);
  const navigate = useNavigate();

  const [filter, setFilter] = useState({
    no_of_result: 12,
    page: 1,
    search: null,
    templateType: "all",
    startDate: null,
    endDate: null,
  });

  const toUTCStartOfDay = (date) => {
    if (!date) return null;
    // Take local midnight (IST), then convert to UTC
    const start = new Date(date);
    start.setHours(0, 0, 0, 0);
    return start.toISOString();
  };

  const toUTCEndOfDay = (date) => {
    if (!date) return null;
    // Take local 23:59:59.999 (IST), then convert to UTC
    const end = new Date(date);
    end.setHours(23, 59, 59, 999);
    return end.toISOString();
  };

  useEffect(() => {
    // if (range?.from || range?.to) {
    setSelectedPage(1);
    setFilter((prev) => ({
      ...prev,
      startDate: toUTCStartOfDay(range?.from),
      endDate: toUTCEndOfDay(range?.to),
    }));

    // }
    console.log("filterAaA", filter);
  }, [range]);

  const debouncedFilter = useDebounce(filter, 500);
  const changeFilterCriteria = (e) => {
    if (e.target.name == "search") {
      filter.page = 1;
      setSelectedPage(1);
    }
    console.log(e.target.name, e.target.value);
    filter[e.target.name] = e.target.value;
    setFilter({ ...filter });
    console.log("filter", filter);
  };

  const handleCheckboxChange = (templateId) => {
    setSelectedFiles((prev) =>
      prev.includes(templateId)
        ? prev.filter((id) => id !== templateId)
        : [...prev, templateId]
    );

    console.log(
      "selectChange",
      selectedFiles.includes(templateId)
        ? selectedFiles.filter((id) => id !== templateId)
        : [...selectedFiles, templateId]
    );
  };

  const changeFilterCriteriaByName = (name, value) => {
    console.log(name, value);
    filter[name] = value;
    setFilter({ ...filter });
    console.log("filter", filter);
  };

  useEffect(() => {
    const loadExpertUsers = async () => {
      try {
        const response = await listExpertUsers({ userTypeFilter: 0 });
        const usersData = response?.data || [];
        setExpertUsers(usersData);

        // Automatically select all users when expert users are loaded
        const allUserIds = usersData.map(user => user.id);
        setFilter(prevFilter => ({
          ...prevFilter,
          users: allUserIds
        }));
      } catch (error) {
        console.error("Error loading expert users:", error);
      }
    };

    loadExpertUsers();
  }, []);

  const selectedUsers = filter.users || [];

  const selectedLabel = (() => {
    if (selectedUsers.length === expertUsers.length && expertUsers.length > 0) {
      return "All Team Members";
    }

    if (selectedUsers.length === 1) {
      const user = expertUsers.find((u) => u.id === selectedUsers[0]);
      return user ? `${user.firstName} ${user.lastName}` : "1 Selected";
    }

    if (selectedUsers.length > 1) {
      return `${selectedUsers.length} Selected`;
    }

    return "All Team Members";
  })();

  useEffect(() => {
    changeFilterCriteriaByName("page", selectedPage);
  }, [selectedPage]);

  const deleteSelected = async (data) => {
    if (Array.isArray(data)) {
      try {
        // Run all delete API calls in parallel
        await Promise.all(data.map((element) => deleteTemplateById(element)));

        // Update UI list by removing deleted templates
        setTemplatesShow((prev) =>
          prev.filter((template) => !data.includes(template.id))
        );
        getAllTemplates();
        // If we reached here, all deletes succeeded ✅
        showAlert({
          title: "Template Notification",
          message: "Selected templates deleted successfully.",
          variant: "success",
        });
      } catch (err) {
        console.error("Error deleting templates:", err);
        showAlert({
          title: "Template Notification",
          message: err?.response?.data?.message ?? "Something went wrong",
          variant: "danger",
        });
      }
    } else {
      try {
        // Delete single template
        const response = await deleteTemplateById(data);

        // Update UI list by removing that template
        setTemplatesShow((prev) =>
          prev.filter((template) => template.id !== data)
        );
        getAllTemplates();
        showAlert({
          title: "Template Notification",
          message: "Template deleted successfully.",
          variant: "success",
        });
      } catch (err) {
        console.error("Error deleting template:", err);
        showAlert({
          title: "Template Notification",
          message: err?.response?.data?.message ?? "Something went wrong",
          variant: "danger",
        });
      }
    }

    // Reset state after deletion
    setTemplatesToDelete(null);
    setSelectedFiles([]);
    setShowModal(false);
  };

  const copyToNewTemplate = async (template) => {
    try {
      const formData = new FormData();

      // clone the template deeply and remove id so it's always new
      const cloned = JSON.parse(JSON.stringify(template));
      cloned.id = null;

      // 1. Add simple string values
      formData.append("templateType", cloned.templateType || "digital");
      formData.append("name", cloned.name);

      // 2. Handle images
      cloned.schema.forEach((section) => {
        section.fields.forEach((field, fieldIdx) => {
          if (field.type === "arrayOfImages") {
            field.value.forEach((val, imgIdx) => {
              // only append if file exists
              if (val?.file) {
                formData.append("images", val.file);
                // replace with preview string for JSON
                field.value[imgIdx] = val.preview;
              }
            });
          }
        });
      });

      // 3. Add schema as JSON (without File objects)
      formData.append("schema", JSON.stringify(cloned.schema));

      // 4. Call create API
      const response = await createTemplate(formData);
      setTemplateToCopy(null);
      setShowCopyModal(false);
      let badge = null;
      if (response?.data?.templateType === "field") {
        badge = { text: "Field", className: "badge-success" };
      } else {
        badge = { text: "Digital", className: "badge-primary" };
      }
      if (!(templatesShow.length === filter.no_of_result)) {
        setTemplatesShow([
          ...templatesShow,
          {
            ...response?.data,
            img: "/images/file-type-icon-pdf.svg",
            badge,
            author:
              response?.data?.createdBy?.roleId === 2 ? response?.data.createdBy.companyName :
                response?.data.createdBy.firstName +
                " " +
                response?.data.createdBy.lastName,
          },
        ]);
      }
      setTotalTemplatesCount(totalTemplatesCount + 1);
      showAlert({
        title: "Template Notification",
        message: "Template copied successfully.",
        variant: "success",
      });

      console.log("Template copied:", response);
    } catch (err) {
      console.error("Error copying template:", err);
      showAlert({
        title: "Template Notification",
        message: err?.response?.data?.message ?? "Something went wrong",
        variant: "danger",
      });
    }
  };

  const handleSelectAllTemplates = () => {
    if (selectedFiles.length === templatesShow.length) {
      setSelectedFiles([]);
    } else {
      const filesToDownload = templatesShow?.map((e) => e.id);
      setSelectedFiles(filesToDownload);
    }
  };

  const changeTemplateFilterCriteriaByName = (name, value) => {
    setFilter((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const reportFilterHandler = (type) => {
    setReportFilter(type);
  };

  const onCopyTemplateNameChange = (e) => {
    const inputValue = e.target.value;

    if (inputValue.trim() === "" && inputValue !== "") {
      return;
    }
    setTemplateToCopy({ ...templateToCopy, name: inputValue });
  };

  const formatDate = (date) => {
    if (!date) return "From - To Date";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getFullYear();

    return `${month}-${day}-${year}`;
  };
  const BeadcrumbItems = [{ label: "Report Hub", active: true }];
  const ReporttabItem = {
    All: "all",
    "Sessions": "digital",
    "Field": "field",
  };

  const TempletetabItem = {
    All: "all",
    "Sessions": "digital",
    "Field": "field",
  };
  const TemplateLabel = {
    'Digital': 'Session',
    'Field': 'Field'
  }
  const getAllTemplates = async () => {
    setLoading(true);
    try {
      const query = { ...debouncedFilter };
      // remove templateType if "all"
      if (query.templateType === "all") {
        delete query.templateType;
      }
      const data = await getTemplates(query);

      const tempplateFiles = data?.data || [];

      const createdFiles = tempplateFiles.map((element) => {
        let badge = null;
        if (element.templateType === "field") {
          badge = { text: "Field", className: "badge-success" };
        } else {
          badge = { text: "Digital", className: "badge-primary" };
        }
        return {
          ...element,
          img: "/images/file-type-icon-pdf.svg",
          badge,
          author:
            element?.createdBy?.roleId === 2 ? element?.createdBy?.companyName : element.createdBy.firstName + " " + element.createdBy.lastName,
        };
      });
      console.log("filessss", createdFiles);
      setSelectedFiles([]);
      setTotalTemplatesCount(data?.totalResult);
      setTemplatesShow(createdFiles || []); // adjust based on API response shape
    } catch (err) {
      console.error("Error fetching templates:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllTemplates();
  }, [debouncedFilter]); // re-fetch when filters change

  // Sample data for 8 templates

  const reportHistory = [];
  return (
    <>
      <Row className="align-items-end justify-content-between mb-4">
        <Col lg="7">
          <CustomBreadcrumb items={BeadcrumbItems} />
          <PageTitle title="Report Hub" />
        </Col>
        <Col lg="5" className="text-end">
          <Dropdown>
            <Dropdown.Toggle
              variant="blue"
              className="btn btn-md dropdown-toggle d-inline-flex align-items-center justify-content-end gap-1"
              align="end"
            >
              Create Template
            </Dropdown.Toggle>

            <Dropdown.Menu className="template-dropdown-menu dropdown-menu-end">
              <Row className="gx-2">
                <Col md="6">
                  <Link
                    to="digital-template"
                    className="template-dropdown-item bg-blue-100"
                    onClick={collapseSidebarForReportHub}
                  >
                    <div className="template-dropdown-icon rounded-pill bg-white text-blue-600">
                      <PlusIcon />
                    </div>
                    <p className="fs-14 fw-500 text-gray-700 mt-2 mb-0">
                      Create Session
                      <br /> Template
                    </p>
                  </Link>
                </Col>
                <Col md="6">
                  <Link
                    to="field-template"
                    className="template-dropdown-item bg-green-100"
                    onClick={collapseSidebarForReportHub}
                  >
                    <div className="template-dropdown-icon rounded-pill bg-white text-green-600">
                      <PlusIcon />
                    </div>
                    <p className="fs-14 fw-500 text-gray-700 mt-2 mb-0">
                      Create Field
                      <br /> Template
                    </p>
                  </Link>
                </Col>
              </Row>
            </Dropdown.Menu>
          </Dropdown>
        </Col>
      </Row>
      <Row>
        <Col md={showReportInfo ? "9" : "12"}>
          <CardWrapper>
            <Row>
              <Col md="9">
                <div className="btn-tabs">
                  <Button
                    as="button"
                    variant=""
                    className={`btn-md ${reportFilter === "template" ? "active" : ""
                      }`}
                    onClick={() => reportFilterHandler("template")}
                  >
                    Templates
                  </Button>
                  <Button
                    as="button"
                    variant=""
                    className={`btn-md ${reportFilter === "report-history" ? "active" : ""
                      }`}
                    onClick={() => reportFilterHandler("report-history")}
                  >
                    Report History
                  </Button>
                </div>
              </Col>
              <Col md="3">
                <input
                  onChange={changeFilterCriteria}
                  name="search"
                  className="form-control form-control-search"
                  aria-label="Search Input"
                  placeholder="Search by any keyword here..."
                  autocomplete="off"
                  type="text"
                />
              </Col>
            </Row>
          </CardWrapper>
          <CardWrapper className="full-box-1 mt-3">
            <Row className="align-items-center mb-4">
              <Col md="3">
                <h2 className="fs-20 fw-600 mb-0">
                  {reportFilter === "template"
                    ? `Total Templates (${totalTemplatesCount ?? 0})`
                    : `Report History (${reportHistory.length})`}
                </h2>
              </Col>
              <Col md="9">
                <Row className="align-items-center justify-content-md-end gy-3 gy-lg-0">
                  {reportFilter === "report-history" && (
                    <Col className="col-md-3">
                      <Dropdown
                        show={showUsersDropdown}
                        onToggle={(isOpen) => setShowUsersDropdown(isOpen)}
                      >
                        <Dropdown.Toggle
                          variant="light"
                          className="filter-dropdown-button form-control dropdown-toggle-arrow w-100 text-start"
                          align="end"
                        >
                          {selectedLabel}
                        </Dropdown.Toggle>

                        <Dropdown.Menu
                          className="filter-dropdown-menu dropdown-menu-end p-0"
                          align="end"
                          popperConfig={{
                            modifiers: [
                              {
                                name: "offset",
                                options: { offset: [0, 5] },
                              },
                            ],
                          }}
                        >

                          {/* Select All */}
                          <div className="px-3 pt-2 border-bottom">
                            <Form.Check
                              className="checkbox-primary mb-2"
                              type="checkbox"
                              label="Select All"
                              id="checkbox-all"
                              checked={
                                filter.users.length === expertUsers.length &&
                                expertUsers.length > 0
                              }
                              onChange={(e) => {
                                const newUsers = e.target.checked
                                  ? expertUsers.map((u) => u.id)
                                  : [];
                                setFilter({ ...filter, users: newUsers });
                              }}
                            />
                          </div>

                          {/* Users List */}
                          <div className="filter-dropdown-menu-list px-3 py-2 border-bottom" style={{ maxHeight: "250px", overflowY: "auto" }}>
                            {expertUsers.map((user) => (
                              <Form.Check
                                key={user.id}
                                className="checkbox-primary mb-3"
                                type="checkbox"
                                label={`${user.firstName} ${user.lastName}`}
                                id={`user-${user.id}`}
                                checked={filter.users.includes(user.id)}
                                onChange={(e) => {
                                  const updatedUsers = e.target.checked
                                    ? [...filter.users, user.id]
                                    : filter.users.filter((id) => id !== user.id);

                                  setFilter({ ...filter, users: updatedUsers });
                                }}
                              />
                            ))}
                          </div>
                          <div className="p-2 d-flex align-items-center justify-content-between">
                            <button
                              className="btn btn-sm btn-reset text-blue"
                              onClick={() => {
                                setFilter({
                                  ...filter,
                                  users: expertUsers.map((u) => u.id),
                                });
                                setShowUsersDropdown(false);
                              }}
                            >
                              Reset
                            </button>

                            <button
                              className="btn btn-sm btn-blue"
                              onClick={() => {
                                setShowUsersDropdown(false);
                              }}
                            >
                              Okay
                            </button>
                          </div>

                        </Dropdown.Menu>
                      </Dropdown>
                    </Col>
                  )}

                  <Col className="col-md-4">
                    <Dropdown align="end">
                      <Dropdown.Toggle
                        as="button"
                        id="to-date"
                        className="filter-dropdown-button form-control dropdown-toggle-calendar dropdown-toggle-none d-flex align-items-center justify-content-between gap-2 w-100"
                      >
                        {range?.from && range?.to
                          ? `${formatDate(range?.from)} - ${formatDate(
                            range?.to
                          )}`
                          : "From - To Date"}

                        <Image
                          src="/images/calendar-dots.svg"
                          alt="Calendar Check Icon"
                        />
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="calendar-dropdown-menu dropdown-menu dropdown-menu-end">
                        <DayPicker
                          mode="range"
                          selected={range}
                          onSelect={setRange}
                        />
                      </Dropdown.Menu>
                    </Dropdown>
                  </Col>

                  <Col className="col-auto">
                    {/* <Tabs tabItem={tabItem} /> */}
                    <Tabs
                      tabItem={reportFilter === "report-history" ? ReporttabItem : TempletetabItem}
                      changeFunction={changeTemplateFilterCriteriaByName}
                      changeValue={"templateType"}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
            {selectedFiles?.length > 0 && (
              <div className="bg-blue-100 p-3 rounded-3 d-md-flex align-items-md-center justify-content-md-between mb-4">
                <div className="d-flex align-items-center gap-3 mb-3 mb-md-0">
                  <Button
                    as="button"
                    variant="white"
                    className="btn-md border-0 shadow-none text-blue"
                    onClick={handleSelectAllTemplates}
                  >
                    {selectedFiles.length === templatesShow.length
                      ? "Deselect All"
                      : "Select All"}
                  </Button>
                  <p className="fs-18 fw-semibold mb-0">
                    {selectedFiles?.length}{" "}
                    {selectedFiles.length > 1 ? "items" : "item"} selected
                  </p>
                </div>

                {reportFilter === "template" ? (
                  <Button
                    as="button"
                    variant="white"
                    className="btn-md border-0 shadow-none text-danger d-flex align-items-center gap-1"
                    onClick={() => {
                      setTemplatesToDelete(selectedFiles.map((e) => e));
                      setShowModal(true);
                    }}
                  >
                    <TrashIcon />
                    Delete Selected
                  </Button>
                ) : (
                  <Button
                    as="button"
                    variant="primary"
                    className="btn-md d-flex align-items-center gap-1"
                  >
                    <Image
                      src="/images/download-white.svg"
                      width={18}
                      height={18}
                      alt="Download White Icon"
                    />
                    Download Selected
                  </Button>
                )}
              </div>
            )}

            {reportFilter === "template" ? (
              <>
                <Row className="gy-3 gy-lg-4 gx-3 gx-lg-4">
                  {templatesShow?.map((template) => {
                    const isChecked = selectedFiles.some(
                      (element) => element === template.id
                    );
                    return (
                      <Col xxl="3" lg="4" md="6" key={template?.id}>
                        <div className="file-info-box">
                          <div
                            className="file-info-box-body cursor-pointer"
                            onClick={() => {
                              setTemplateToPreview(template);
                              setShowPreviewModal(true);
                            }}
                          >
                            <div className="d-flex align-items-start justify-content-between gap-2">
                              <Image
                                className="rounded-3 object-fit-cover"
                                src={template?.img}
                                width={64}
                                height={64}
                                alt="PDF File"
                              />
                              <div className="d-flex align-items-start gap-2">
                                <span
                                  className={`badge ${template?.badge?.className}`}
                                >
                                  {TemplateLabel[template?.badge?.text]}
                                </span>
                                <label
                                  className="form-check-label align-items-center"
                                  htmlFor={template?.id}
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <input
                                    className="form-check-input"
                                    id={template?.id}
                                    type="checkbox"
                                    checked={isChecked}
                                    onChange={(e) => (
                                      e.stopPropagation(),
                                      handleCheckboxChange(template?.id)
                                    )}
                                  />
                                </label>
                              </div>
                            </div>
                            <h3 className="text-truncate fs-14 fw-medium text-gray-700 mb-0 mt-3">
                              {template?.name}
                            </h3>
                            <ul className="d-md-flex align-items-md-center gap-2 list-unstyled mt-2 mb-0">
                              <li className="fs-12 fw-medium text-gray-500">
                                Created on{" "}
                                {formatDate(new Date(template.createdAt))}
                              </li>
                              <li className="dot-separator"></li>
                              <li className="fs-12 fw-medium text-gray-500">
                                {template?.author}
                              </li>
                            </ul>
                          </div>
                          <div className="file-info-btns">
                            <Button
                              as="button"
                              variant="transparent"
                              onClick={() => (
                                setTemplatesToDelete(template?.id),
                                setShowModal(true)
                              )}
                              className="fs-14 fw-500 hover-text-danger d-flex align-content-center justify-content-center gap-1 w-100"
                            >
                              <span className="icon-text-wrapper">
                                <TrashIcon />
                                <span className="text-danger icon-text-label">Delete</span>
                              </span>
                            </Button>
                            <Button
                              as="button"
                              variant="transparent"
                              onClick={() => {
                                setTemplateToCopy(template);
                                setShowCopyModal(true);
                              }}
                              className="fs-14 fw-500 hover-text-green d-flex align-content-center justify-content-center gap-1 w-100"
                            >
                              <span className="icon-text-wrapper">
                                <CopyIcon />
                                <span className="text-green icon-text-label">Copy</span>
                              </span>
                            </Button>
                            <Button
                              as="button"
                              variant="transparent"
                              onClick={(e) => {
                                collapseSidebarForReportHub();
                                template.templateType === "field"
                                  ? navigate(
                                    "/report-hub/field-template/" +
                                    template?.id
                                  )
                                  : navigate(
                                    "/report-hub/digital-template/" +
                                    template?.id
                                  );
                              }}
                              className="fs-14 fw-500 hover-text-blue d-flex align-content-center justify-content-center gap-1 w-100"
                            >
                              <span className="icon-text-wrapper">
                                <EditIcon />
                                <span className="text-blue icon-text-label">Edit</span>
                              </span>
                            </Button>
                          </div>
                        </div>
                      </Col>
                    );
                  })}
                  {/* {templatesShow?.length > 8 && (
                    <Col md="12" className="text-center mt-5">
                      <Button variant="outline-secondary" className="md">
                        Load More
                      </Button>
                    </Col>
                  )} */}
                </Row>
                <TablePagination
                  selectedPage={selectedPage}
                  setSelectedPage={setSelectedPage}
                  totalResults={totalTemplatesCount}
                  resultsPerPage={12}
                />
              </>
            ) : (
              <Row className="gy-3 gy-lg-4 gx-3 gx-lg-4">
                {reportHistory?.map((report) => (
                  <Col xxl="3" lg="4" md="6" key={report.id}>
                    {/* active: class when item is select */}
                    <div className="file-info-box">
                      <div className="file-info-box-body">
                        <div className="d-flex align-items-start justify-content-between gap-2">
                          <Image
                            className="rounded-3 object-fit-cover"
                            src={report.img}
                            width={64}
                            height={64}
                            alt="PDF File"
                          />
                          <div className="d-flex align-items-start gap-2">
                            <span className={`badge ${report.badge.className}`}>
                              {report.badge.text}
                            </span>
                            <label
                              className="form-check-label align-items-center"
                              htmlFor={report.id}
                            >
                              <input
                                className="form-check-input"
                                id={report.id}
                                type="checkbox"
                              />
                            </label>
                          </div>
                        </div>
                        <h3 className="text-truncate fs-14 fw-medium text-gray-700 mb-0 mt-3">
                          {report.name}
                        </h3>
                        <ul className="d-md-flex align-items-md-center gap-2 list-unstyled mt-2 mb-0">
                          <li className="fs-12 fw-medium text-gray-500">
                            Created on {report.created}
                          </li>
                          <li className="dot-separator"></li>
                          <li className="fs-12 fw-medium text-gray-500">
                            {report.author}
                          </li>
                        </ul>
                      </div>
                      <div className="file-info-btns">
                        <Button
                          as="button"
                          variant="transparent"
                          className="fs-14 fw-500 hover-text-blue d-flex align-content-center justify-content-center gap-1 w-100"
                        >
                          <span className="icon-text-wrapper">
                            <DownloadIcon />
                            <span className="icon-text-label">Download</span>
                          </span>
                        </Button>
                        <Button
                          as="button"
                          variant="transparent"
                          className="fs-14 fw-500 hover-text-green d-flex align-content-center justify-content-center gap-1 w-100"
                          onClick={() => {
                            setShowReportInfo(true);
                            collapseSidebarForReportHub();
                          }}
                        >
                          <span className="icon-text-wrapper">
                            <InfoIcon />
                            <span className="icon-text-label">
                              View Details
                            </span>
                          </span>
                        </Button>
                      </div>
                    </div>
                  </Col>
                ))}
                {reportHistory?.length > 8 && (
                  <Col md="12" className="text-center mt-5">
                    <Button variant="outline-secondary" className="md">
                      Load More
                    </Button>
                  </Col>
                )}
              </Row>
            )}
          </CardWrapper>
        </Col>
        {showReportInfo && (
          <Col md="3">
            <CardWrapper className="p-0 full-box-0">
              <div className="p-3 border-bottom border-grey-200 d-flex align-items-center justify-content-between gap-3">
                <h2 className="h5 fw-semibold mb-0">Report Information</h2>
                <button
                  type="button"
                  className="btn-reset"
                  onClick={() => {
                    setShowReportInfo(false);
                    expandSidebarForReportHub();
                  }}
                >
                  <Image src="/images/btn-close-square.svg" />
                </button>
              </div>
              <div className="p-3">
                <Image
                  src="/images/file-type-icon-pdf.svg"
                  width={72}
                  height={72}
                  alt="PDF Icon"
                />
                <div className="d-flex align-items-center gap-2 my-4">
                  <span className="badge badge-primary">Digital</span>
                  <p className="fs-20 fw-semibold text-gray-700 mb-0">
                    Report Name
                  </p>
                </div>

                <div className="border-top border-grey-200 py-3">
                  <p className="text-gray-400 fw-400 mb-1">Created By</p>
                  <p className="fs-16 text-gray-700 fw-400 mb-0">Expert name</p>

                  <br />
                  <p className="text-gray-400 fw-400 mb-1">Creation Date</p>
                  <p className="fs-16 text-gray-700 fw-400 mb-0">08-12-2025</p>
                </div>

                <div className="border-top border-grey-200 py-3">
                  <p className="text-gray-400 fw-400 mb-1">Modified By</p>
                  <p className="fs-16 text-gray-700 fw-400 mb-0">Admin Name</p>

                  <br />
                  <p className="text-gray-400 fw-400 mb-1">Modification Date</p>
                  <p className="fs-16 text-gray-700 fw-400 mb-0">08-15-2025</p>
                </div>

                <div className="border-top border-grey-200 py-3">
                  <Button variant="primary" className="w-100">
                    Download Report
                  </Button>
                </div>
              </div>
            </CardWrapper>
          </Col>
        )}
      </Row>

      <Modal
        className="info-modal"
        show={!!showModal}
        onHide={() => setShowModal(false)}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          <div className="text-center">
            <Image src="/images/delete-badge-red.svg" alt="Delete Badge" />
            <h2 className="fs-2 fw-semibold text-gray-700 mt-5 mb-2">
              Are you sure you want to delete selected templates?
            </h2>

            <div className="d-flex align-items-center gap-3">
              <Button
                variant="primary"
                className="btn w-100 mt-5"
                onClick={() => deleteSelected(templatesToDelete)}
              >
                Yes, Delete It!
              </Button>
              <Button
                variant="gray"
                className="btn w-100 mt-5"
                onClick={() => setShowModal(false)}
              >
                No, Not Yet
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="info-modal"
        show={!!showCopyModal}
        onHide={() => setShowCopyModal(false)}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          <div className="text-center">
            <Image src="/images/check-badge-green.svg" alt="Check Badge" />
            <h2 className="fs-2 fw-semibold text-gray-700 my-4">
              Are you sure you want to copy selected template?
            </h2>

            <input
              type="text"
              name="name"
              onChange={onCopyTemplateNameChange}
              value={templateToCopy?.name}
              className="form-control"
              aria-label="Template Name"
              placeholder="Template Name"
              autoComplete="off"
            />

            <div className="d-flex align-items-center gap-3">
              <Button
                variant="primary"
                className="btn w-100 mt-5"
                onClick={() => copyToNewTemplate(templateToCopy)}
              >
                Create
              </Button>
              <Button
                variant="gray"
                className="btn w-100 mt-5"
                onClick={() => setShowCopyModal(false)}
              >
                Cancel
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Quick Preview Modal */}
      <Modal
        className="quick-preview-modal preview-modal"
        show={!!showPreviewModal}
        onHide={() => (setTemplateToPreview(null), setShowPreviewModal(false))}
        centered
        size="xl"
      >
        <Modal.Header
          className="d-flex align-items-center justify-content-between gap-4 px-4 py-3 border-0 rounded-4"
          closeButton
        >
          <Modal.Title className="fs-20 fw-semibold text-gray-700">
            {templateToPreview?.name}
          </Modal.Title>
          <Button
            variant="primary"
            onClick={(e) => {
              templateToPreview.templateType === "field"
                ? navigate(
                  "/report-hub/field-template/" + templateToPreview?.id
                )
                : navigate(
                  "/report-hub/digital-template/" + templateToPreview?.id
                );
            }}
            className="btn-md d-flex align-items-center gap-2"
          >
            <EditIcon />
            Edit Template
          </Button>
        </Modal.Header>
        <Modal.Body className="p-0">
          <ReportPreview data={templateToPreview} />
        </Modal.Body>
      </Modal>
      {/* Quick Preview Modal */}
    </>
  );
};

export default ReportHub;
